import { useEffect } from 'react';

interface ApiWithClear {
  clear: (endpoint: string) => void;
}

/**
 * Clears the API cache for a specific endpoint when the component unmounts.
 * Useful for preventing stale cached requests when navigating away from
 * data grid views.
 *
 * Under the new Data Client-backed Api, `clear()` delegates to the
 * controller's invalidate path — next read refetches. Signature is
 * unchanged.
 */
export const useClearApiCacheOnUnmount = (
  api: ApiWithClear,
  endpoint: string
): void => {
  useEffect(() => {
    return () => {
      api.clear(endpoint);
    };
  }, [api, endpoint]);
};
